// 公共js方法
export default {
  cheoxList(that, name, type) {
    that.columnList = [];
    that.columnList = JSON.parse(
      JSON.stringify(that.searchFormData.filterData.queryCriteria)
    );
    let obj = {
      type: type,
      paramValue: "",
      orderBy: "",
      paramName: name
    };
    that.columnList.forEach((v, index) => {
      if (v && v.paramName == name && name != "DATE_CODE") {
        delete that.columnList[index];
      }
      if (v && name == "DATE_CODE" && v.paramName == "date_code") {
        delete that.columnList[index];
      }
    });
    that.columnList.push(obj);

    let data = {
      colParam: that.columnList,
      reportName: that.reportName
    };
    data.colParam = that.columnList.filter(n => n);
    return that.$q.common.reportGetIndexInfo({data: data}).then(res => {
      if (type == "string") {
        that.$set(that.headerFilterOptions, name, res.data.string);
      } else {
        that.$set(that.headerFilterOptions, name, res.data.numerical);
      }
    });
  },
  // 确认筛选
  confirmFilter(that, filterParam, tableName) {
    let emitType = filterParam.filter.type
    let sendType = "string";
    that.loading = true;
    let data = filterParam;
    let name = data.prop;
    let content = data.filter.checked;
    let number = data.filter.number; //大小于字符转换
    let orderBy = data.filter.sort; //排序
    // console.log(number);
    var str = "";
    //比较字符转换
    console.log('emitType',emitType)
    if (emitType == 1) {
      sendType = ">";
    } else if (emitType == 2) {
      sendType = "<";
    } else if (emitType == 3) {
      sendType = "=";
    } else if (emitType == 4) {
      sendType = ">=";
    } else if (emitType == 5) {
      sendType = "<=";
    } else if (emitType == 6) {
      sendType = "!=";
    } else if (emitType == 7) {
      sendType = "between";
    } else {
      sendType = filterParam.cloumnType;
    }
    if (number.length > 0) {
      //判断是string类型的列还是number
      number.splice(0, 1);
      content = number;
    }
    if (data.type == 1) {
      //判断是确认筛选还是重置
      that.searchFormData.filterData.queryCriteria = that.searchFormData.filterData.queryCriteria.filter(v=>v.paramName != name)
      that.$store.commit("headerFilters/restHeaderFilter", {
        columnName: name,
        tableName: tableName
      });
    } else {

      for (var i = 0; i < content.length; i++) {
        str += content[i] + ",";
      }
      str = str.substr(0, str.length - 1);
      let arr = that.searchFormData.filterData.queryCriteria;
      let obj = {
        orderBy: orderBy,
        paramName: name,
        paramValue: str,
        type:sendType
      };
      arr.push(obj)
      console.log('obj',obj)
      arr.forEach((v, index) => {
    
        if (v.paramName == name) {
          v.paramValue = str;
          v.orderBy = orderBy;
          v.type = sendType;
          return;
        } else {
          arr.push(obj);
        }
      });
      that.searchFormData.filterData.queryCriteria = this.objTrim(arr);
      that.tableData.pageNum = 1;
      that.searchFormData.pageNum = 1
     
    }
    that.$q.common
      .reportSearch({data: that.searchFormData})
      .then(res => {
        res.data.records.forEach((v,index)=>{
            v.id = v.modelName + index+( '' + that.tableData.pageNum)
          })
        that.tableData = res.data;
      })
      .catch(err => {
        //that.$message(err.message)
      })
      .finally(_ => {
        that.loading = false;
        that.pageTure = true;
      });
  },
  // 数组对象元素去重
  objTrim(a) {
    let obj = {};
    let test = a.reduce((cur, next) => {
      obj[next.paramName] ? "" : (obj[next.paramName] = true && cur.push(next));
      return cur;
    }, []);
    return test;
  },
  }
